<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params }">
      <!-- <Details
        v-if="visible"
        :billId="params.row.id"
        :check_bill_number="params.row.bill_number"
        :codStatus="params.row.types"
        :total_amount="params.row.total_amount"
      ></Details> -->
      <Details v-if="visible" :row="params"></Details>
    </template>
    <template #Email="{ visible, params }">
      <EmailDetails
        :send="sendEmail"
        v-if="visible"
        :row="params"
      ></EmailDetails>
    </template>

    <template #WriteOffSlot="{ visible, params, close }">
      <WriteOffOptimization v-if="visible" :params="params" :close="close" />
    </template>
  </cTable>
</template>

<script>
import {
  getB2bBill,
  getB2bBillUSer,
  addB2bBill,
  updateB2bBill,
  ConfirmB2bBill,
  getDetails,
  b2bReStatistics,
  b2bWriteOff,
  getConfig,
  delDouBill,
  getB2bBillDetails,
  getB2bContractHeader,
  againBillAmount,
  postConfirm,
  append,
  remove,
  recalculate,
  getBatchWriteOffNext,
  batchWriteOff,
  batchCancelConfirm,
  getWriteOffRecord,
  previewEmail,
  sendBillEmail,
  adjust,
  getWaitOffData,
  exportMergeExcel
} from "@/api/double/bill_hq";
import {getB2Bbill} from "@/api/finance/b2b_details";
import {getAllClient, searchClient} from "@/api/user/client";
import {getKeysType, getSelectType} from "@/api/public";
import cTable from "@/base/common/index";
import Details from "./details";
import {getUser} from "@/api/user/internal";
import {getBank} from "@/api/finance/bank";
import {getService} from "@/api/double/list";
import {useModal} from "./rate.js";
import EmailDetails from "../bill/email_details";
import invoice from "@/components/invoice";
import {Button} from "iview";
import {markAlreadySendEmail} from "@/api/order/other";
import WriteOffOptimization from "@/view/finances/b2b_bill_hq/writeOffOptimization.vue";

export default {
  name: "b2b_bill_hq",
  components: {
    WriteOffOptimization,
    cTable,
    Details,
    EmailDetails,
    invoice
  },
  methods: {
    sendEmail(id, callback) {
      return sendBillEmail(id);
    },
    exportMergeExcel
  },
  activated() {
    if (this.$store.state.user.pageUrl) {
      if (typeof this.$store.state.user.pageUrl === 'object') {
        this.$refs["table"].$refs["header"].searchForm.keywords = this.$store.state.user.pageUrl.keywords;
        this.$refs["table"].$refs["header"].searchForm.keywordsType = this.$store.state.user.pageUrl.keywordsType;
      } else {
        this.$refs["table"].$refs[
          "header"
          ].searchForm.keywords = this.$store.state.user.pageUrl;
      }

      this.$store.state.user.pageUrl = "";
      this.$refs["table"].getList();
    }
  },
  data() {
    let _this = this;
    return {
      methods: {
        list: getB2bBill,
        getB2bBillUSer,
        addB2bBill,
        updateB2bBill,
        ConfirmB2bBill,
        getDetails,
        b2bReStatistics,
        b2bWriteOff,
        getConfig,
        delDouBill,
        getB2bBillDetails,
        getB2bContractHeader,
        againBillAmount,
        getKeysType,
        getBank,
        postConfirm,
        append,
        remove,
        recalculate,
        getBatchWriteOffNext,
        batchWriteOff,
        batchCancelConfirm,
        getWriteOffRecord,
        previewEmail,
        adjust,
        getWaitOffData
      },
      modals: {
        adjust: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = JSON.parse(JSON.stringify(row));
              data.src = row.src.src;
              this.$page
                .handleRequestMethods("adjust", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("调账,核销"),
            modalBind: {
              width: 800
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              change_amount: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            {before_amount: 12, before_amount_currency: 12},
            {change_amount: 12, change_amount_currency: 12},
            {after_amount: 12, after_amount_currency: 12},
            {src: 24},
            {remarks: 24}
          ],
          fields: [
            {
              name: () => this.$tz("核销,金额"),
              key: "before_amount",
              component: "Input",
              placeholder: () => " ",
              disabled: true
            },
            {
              name: () => this.$tz("核销,币种"),
              key: "before_amount_currency",
              component: "Input",
              placeholder: () => " ",
              disabled: true
            },
            {
              name: () => this.$tz("调账,金额"),
              key: "change_amount",
              component: "InputNumber",
              placeholder: () => this.$tz("调账,金额"),
              default: 0,
              bind: {
                style: "width:100%"
              },
              methods: {
                "on-change"({field, formData}) {
                  formData.after_amount = parseFloat(
                    parseFloat(
                      parseFloat(formData.before_amount) +
                      parseFloat(formData.change_amount || 0)
                    ).toFixed(2)
                  );
                }
              }
            },
            {
              name: () => this.$tz("调账,币种"),
              key: "change_amount_currency",
              component: "Input",
              placeholder: () => " ",
              disabled: true
            },
            {
              name: () => this.$tz("最终,核销,金额"),
              key: "after_amount",
              component: "Input",
              placeholder: () => " ",
              disabled: true
            },
            {
              name: () => this.$tz("最终,核销,币种"),
              key: "after_amount_currency",
              component: "Input",
              placeholder: () => " ",
              disabled: true
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: {minRows: 3}
              }
            },
            {
              name: () => this.$tz("附件"),
              key: "src",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx,.pdf,.jpg,.png,.jpeg,.gif"
              },
              methods: {
                beforeUpload({file, formData, field}) {
                  let data = new FormData();
                  data.append("file", file);
                  this.$page
                    .handleRequestMethods("upload", data, true, true)
                    .then(res => {
                      formData[field.key] = {
                        filename: file.name,
                        name: file.name,
                        src: res.payload
                      };
                    });
                  return false;
                }
              }
            }
          ]
        },
        preview: {
          contentSlot: "Email",
          config: {
            modalBind: {
              // draggable: true,
              // transfer: true,
              width: 920
            }
          },
          footer: {show: () => false}
        },
        writeOffList: {
          type: "add",
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true
            }
          },
          table: {
            config: {
              height: 700
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_bill_number",
                minWidth: 130
              },
              {
                name: () => this.$t("check_amount_currency"),
                key: "check_amount_currency",
                minWidth: 100
              },
              {
                name: () => this.$t("check_amount"),
                key: "check_amount",
                minWidth: 100
              },
              {
                name: () => this.$t("transactionNumber"),
                key: "transaction_id",
                minWidth: 100
              },
              {
                name: () => this.$t("writeOffUser"),
                key: "write_off_name",
                minWidth: 100
              },
              {
                name: () => this.$t("check_remarks"),
                key: "write_off_remarks",
                minWidth: 100
              },
              {
                name: () => this.$t("paid_time"),
                key: "pay_time",
                minWidth: 170
              },
              {
                name: () => this.$t("bank_name"),
                key: "bank_name",
                minWidth: 100
              }
            ]
          }
        },
        add: {
          methods: {
            ok({row, close}) {
              this.$page.handleRequestMethods("addB2bBill", row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_ids: [
                {
                  required: true,
                  type: "number",
                  message: this.$t("select") + this.$t("clientName"),
                  trigger: "change"
                }
              ],
              name: [
                {
                  required: true,
                  message: this.$t("enter") + this.$t("codNAme"),
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{client_ids: 24}, {name: 24}],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_ids",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("order_number"),
              options: [],
              config: {label: "account", value: "id"},
              methods: {
                async list({field}) {
                  field.options = (
                    await this.$page.handleRequestMethods("getB2bBillUSer")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            }
          ]
        },
        update: {
          methods: {
            ok({row, close}) {
              this.$page
                .handleRequestMethods("updateB2bBill", row)
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{name: 24}, {remarks: 24}],
          fields: [
            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea"
              }
            }
          ]
        },
        writeOffOptimization: {
          contentSlot: "WriteOffSlot",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1280
            },
            modalContentBind: {
              style: {
                height: "530px"
              }
            }
          },
          footer: {show: () => false}
        },
        writeOff: {
          type: "add",
          methods: {
            ok({row, close}) {
              if (
                row.off_type == 2 &&
                row.account_balances < row.check_amount
              ) {
                this.$Message.warning({
                  content: this.$t("InsufficientBalance"),
                  background: true
                });
                return;
              }
              let data = JSON.parse(JSON.stringify(row));
              delete data.bill_order;
              data.airway_number = this.selectAll.map(
                item => item.airway_number
              );
              if (!data.invoice.is_open) delete data["invoice"];
              this.$page
                .handleRequestMethods(
                  row.batch ? "batchWriteOff" : "b2bWriteOff",
                  data
                )
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            },
            checkTable({row}) {
              let amount = 0;
              row.map(item => {
                amount += parseFloat(item.arrears_amount);
                return;
              });
              this.$refs["form"].formData.check_amount = parseFloat(
                amount.toFixed(2)
              );
              this.$forceUpdate();
            }
          },
          config: {
            modalBind: {
              width: 1200,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              contract_header: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              payment_bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ],
              payment_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "date",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {off_type: 12, contract_header: 12},
            {payment_bank: 12, payment_time: 12},
            {check_amount: 12, check_amount_currency: 12},
            {account_balances: 24},
            {transaction_id: 24},
            {write_off_remarks: 24},
            {invoice: 24}
          ],
          fields: [
            {
              name: () => this.$tz("是否,开票"),
              key: "invoice",
              render(h, p) {
                if (!p.row.invoice) p.row.invoice = {is_open: 0, amount: ""};
                return h(invoice, {
                  props: {
                    formData: p.row.invoice
                  }
                });
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "write_off_remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 3,
                type: "textarea"
              }
            },
            {
              name: () => this.$t("type"),
              key: "off_type",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("type"),
              default: 1,
              clearable: false,
              options: [
                {label: this.$t("offLine"), value: 1},
                {label: this.$t("onLine"), value: 2}
              ]
            },
            {
              name: () => this.$t("contract_title"),
              key: "contract_header",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contract_title"),
              options: [],
              methods: {
                async list({field}) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getB2bContractHeader"
                    )
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("bank"),
              key: "payment_bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label({row}) {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "id"
              },
              show({row}) {
                return row.off_type == 1;
              },
              methods: {
                async list({field}) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("paid_time"),
              key: "payment_time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("paid_time"),
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              },
              show({row}) {
                return row.off_type == 1;
              }
            },
            {
              name: () => this.$t("account_balances"),
              key: "account_balances",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%"
              },
              default: 0,
              disabled: true,
              show({row}) {
                return row.off_type === 2;
              }
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.0001,
                style: "width:100%"
              },
              default: 0,
              disabled({row}) {
                return row.off_type === 2;
              }
            },
            {
              name: () => this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [
                {label: this.$t("to_rmb"), value: "CNY"},
                {label: this.$t("to_usd"), value: "USD"}
              ]
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              show({row}) {
                return row.off_type == 1;
              },
              placeholder: () => this.$t("enter") + this.$t("transaction_id")
            }
            // {
            //   name: () => this.$t("order_number"),
            //   key: "search_cnbnum",
            //   component: "Input",
            //   placeholder: () =>
            //     this.$t("enter") + this.$t("order_number") + this.$t("search"),
            //   methods: {
            //     "on-search"({ formData }) {
            //       let that = this.$page.getModal("writeOff");
            //       let arr = that.list;
            //       if (formData.search_cnbnum == "") {
            //         that.list = that.billOrder;
            //         return;
            //       }
            //       that.list = arr.filter(
            //         item =>
            //           item.search_cnbnum
            //             .toLowerCase()
            //             .indexOf(formData.search_cnbnum.toLowerCase()) !== -1
            //       );
            //     }
            //   },
            //   bind: {
            //     suffix: "ios-search",
            //     search: true
            //   }
            // }
          ],
          table: {
            config: {
              height: 300,
              checkboxConfig: {
                labelField: "id",
                checkMethod({row}) {
                  return row.children != 1 && row.arrears_amount > 0;
                }
              }
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                minWidth: 130,
                methods: {
                  render({row, value}) {
                    return row.children ? " " : value;
                  }
                }
              },
              {
                name: () => this.$t("reChAmount"),
                key: "to_total_amount",
                minWidth: 130,
                methods: {
                  render({row, value}) {
                    return row.children ? " " : value;
                  }
                }
              },
              {
                name: () => this.$t("check_amount"),
                key: "check_amount",
                minWidth: 130
              },
              {
                name: () => this.$t("check_time"),
                key: "pay_time",
                minWidth: 159
              },
              {
                name: () => this.$t("arrears"),
                key: "arrears_amount",
                minWidth: 130
              }
            ]
          }
        },
        rate: useModal.call(this, "b2b_bill_hq"),
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500
            },
            modalContentBind: {
              style: {
                height: "700px"
              }
            }
          },
          footer: {show: () => false}
        },
        append: {
          methods: {
            ok({row, close}) {
              let airway_numbers = row.airway_numbers
                .split("\n")
                .filter(t => t);
              this.$page
                .handleRequestMethods(row.fn, {airway_numbers, id: row.id})
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_numbers: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{airway_numbers: 24}],
          fields: [
            {
              name: () => this.$t("order_number"),
              key: "airway_numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                rows: 6,
                type: "textarea"
              }
            }
          ]
        }
      },
      footer: {show: () => true},
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            config: {
              label: "value",
              value: "key"
            }
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            },
            methods: {
              "on-change"({searchForm}) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            },
            methods: {
              "on-change"({searchForm}) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },

          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "SelectSearchable",
            options: [],
            config: {label: "account", value: "id"},
            filterable: true,
            methods: {
              "remote-method"({field, formData}, $event) {
                if ($event.length >= 2) {
                  searchClient({keywords: $event}).then(res => {
                    field.options = res.data.payload.rows
                  })
                }
              },
            }
          },
          {
            key: "sale_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label({row}) {
                return row.realname
                  ? row.account + "(" + row.realname + ")"
                  : row.account;
              },
              value: "id"
            }
          },
          {
            key: "bill_status",
            placeholder() {
              return this.$t("select") + this.$t("bill_type");
            },
            component: "Select",
            options: []
          },
          {
            key: "whether_usd",
            placeholder() {
              return (
                this.$t("amount_receivable") +
                "(USD)" +
                this.$t("whether") +
                "0"
              );
            },
            component: "Select",
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ]
          },
          {
            key: "send_marks",
            placeholder() {
              return '是否发送了账单';
            },
            component: "Select",
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ]
          },
          {
            key: "main_contract_header",
            placeholder() {
              return this.$t("select") + this.$t("contract_title");
            },
            component: "Select",
            options: [],
            methods: {
              async list({field}) {
                field.options = (await getB2Bbill()).data.payload;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "service_code",
            placeholder() {
              return this.$t("select") + this.$t("company");
            },
            component: "Select",
            options: [],
            config: {
              label: "service_name",
              value: "service_code"
            }
            // methods: {
            //   async list({ field }) {
            //     let res = (await ()).data.payload;
            //     field.options = res;
            //     this.$forceUpdate();
            //   }
            // }
          },
          {
            key: "department",
            placeholder() {
              return this.$t("select") + this.$t("assistDepartment");
            },
            component: "Select",
            options: [],
            methods: {
              async list({field, searchForm}) {
                let res = (await getSelectType(["CLEARANCE_DEPARTMENT"])).data
                  .payload["CLEARANCE_DEPARTMENT"];
                field.options = res;
                this.$forceUpdate();
              }
            }
          },

          {
            key: "keywordsType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: false,
            options: [],
            methods: {
              list({field, searchForm}) {
                this.$page
                  .handleRequestMethods("getKeysType", "B2B_BILL_KEYWORDS")
                  .then(res => {
                    field.options = res.payload;
                    if (!searchForm[field.key]) {
                      searchForm[field.key] = res.payload[0].value;
                      setTimeout(() => {
                        this.$refs['table'].getList()
                      }, 3000)
                    }
                  });
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: {minRows: 1, maxRows: 2}
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 389
            },
            // {
            //   name: () => this.$t("pushClinet"),
            //   type: "pushClinet",
            //   fnName: "pushClinet",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
              // id: 596,
            },
            {
              name: () => this.$t("resAmount"),
              type: "resAmount",
              fnName: "resAmount",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
              // id: 389,
            },
            {
              name: () => this.$t("batch") + this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
              // id: 389,
            },
            {
              name: () =>
                this.$t("batch") + this.$t("cancel") + this.$t("confirm"),
              type: "batchCancelConfirm",
              fnName: "batchCancelConfirm",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
              // id: 389,
            },
            {
              name: () => this.$tz("调账,核销"),
              type: "adjust",
              fnName: "adjust",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("导出合并账单Excel"),
              type: "exportMergeExcel",
              fnName: "exportMergeExcel",
              bind: {
                type: "error"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            exportMergeExcel() {
              let ids = this.selectAll.map((t) => t.id);
              exportMergeExcel({params: ids}).then(res => {
                if (res.data.code) {
                  // 发生错误
                  this.$Message.error(res.data.msg)
                } else {
                  window.open(res.data.payload)
                }
              })
            },
            adjust() {
              this.handleRequestMethods("getWaitOffData", {
                type: "DBL",
                bill_number: this.selectAll.map(t => t.bill_number)
              }).then(res => {
                res.payload.after_amount = res.payload.before_amount =
                  res.payload.amount;
                res.payload.change_amount_currency = res.payload.after_amount_currency = res.payload.before_amount_currency =
                  res.payload.currency;
                this.getModal("adjust").open(res.payload);
              });
            },
            batchCancelConfirm() {
              let ids = this.selectAll.map(t => t.id);
              this.$Modal.confirm({
                title:
                  this.$t("batch") + this.$t("cancel") + this.$t("confirm"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("batchCancelConfirm", {ids}).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            },
            writeOff() {
              // 新的批量核销逻辑 先读取选择的用户信息和ID
              let customerArray = Array.from(new Set(this.selectAll.map(t => t.client_name)));
              // 需要去重然后判断是否只有一个
              if (customerArray.length !== 1) {
                // 存在多个用户
                return this.$Message.error({
                  content: `不能混合核销用户 ${customerArray.join(', ')} 的账单`,
                  duration: 10
                })
              }
              // 检查是否这些都是待核销的
              let waitForCharge = Array.from(new Set(this.selectAll.map(t => t.status_txt)));
              if (waitForCharge.length !== 1) {
                // 存在多个状态
                return this.$Message.error({
                  content: `选择的账单存在 ${waitForCharge.join(', ')} 等状态，目前只能批量核销待核销的账单`,
                  duration: 10
                })
              }
              // 检查唯一的状态是否为待核销
              let waitForChargeStatus = Array.from(new Set(this.selectAll.map(t => t.status)));
              if (waitForChargeStatus[0] !== 4) {
                // 选择的同一状态但是不是待核销
                return this.$Message.error({
                  content: '选择的账单的状态不是待核销',
                  duration: 10
                })
              }
              // 向后端请求实际执行的数据
              let idArray = Array.from(new Set(this.selectAll.map(t => t.id)));
              this.handleRequestMethods("getBatchWriteOffNext", {params: idArray}).then(res => {
                this.getModal("writeOffOptimization").open(res.payload, function () {
                  this.setTitle(`批量核销用户${res.payload.customer.account}的账单`)
                })
              });
            },
            resAmount() {
              let data = this.selectAll.map(item => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("resAmount"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("recalculate", {
                    ids: data
                  }).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            // 导出
            export() {
              this.exportExc();
            },
            // 新增
            add() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open();
            },
            // 推送
            pushClinet() {
              let data = this.selectAll.map(item => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("pushClinet"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("ConfirmB2bBill", {
                    ids: data
                  }).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          component: this.$hasPermission(402) || true ? "Button" : "span",
          minWidth: 200,
          fixed: "left",
          copy: true,
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({row}) {
              return row.bill_number;
            },
            click({row}) {
              // if (!this.$hasPermission(402)) return;
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            }
          }
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 100,
          align: "left"
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          minWidth: 100,
          align: "left"
        },
        {
          name: () => this.$t("contract_title"),
          key: "main_contract_header",
          minWidth: 110,
          align: "left"
        },
        {
          name: () => this.$t("salesman"),
          key: "sale_name",
          minWidth: 100,
          align: "left"
        },
        {
          name: () => this.$t("发送标记"),
          width: 260,
          key: "sendTime",
          render: (h, params) => {
            if (params.row.sendTime === 0) {
              return h(Button, {
                props: {
                  type: "primary",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '邮件发送标记',
                      content: `<p>是否确认已经发送账单 ${params.row.bill_number} 发送给了客户 ${params.row.client_name}? </p>`,
                      okText: '确认',
                      cancelText: '取消',
                      loading: true,
                      onOk: () => {
                        this.$Spin.show()

                        markAlreadySendEmail(params.row.id).then(res => {
                          this.$Message.success(res.data.msg)
                          this.$refs['table'].getList()
                          this.$Spin.hide()
                          this.$Modal.remove();
                        })
                      },
                    })
                  }
                }
              }, '发送账单')
            } else {
              return h('span', params.row.sendTime)
            }
          }
        },
        {
          name: () => this.$t("b2bName"),
          key: "name",
          align: "left",
          minWidth: 150
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "left",
          minWidth: 150
        },
        {
          name: () => this.$t("total_votes"),
          key: "total_votes",
          align: "left",
          width: 80
        },
        {
          name: () => this.$t("assistDepartment"),
          minWidth: 100,
          key: "department"
        },

        {
          name: () => this.$t("company"),
          key: "service_code",
          align: "left",
          width: 80
        },
        {
          name: () => this.$t("city_t"),
          key: "city",
          align: "left",
          width: 110
        },

        {
          name: () => this.$t("amount_receivable"),
          children: [
            {
              name: () => "USD",
              align: "left",
              key: "total_amount_usd",
              width: 120
            },
            {
              name: () => "CNY",
              align: "left",
              key: "total_amount_cny",
              width: 120
            },
            {
              name: () => "SAR",
              align: "left",
              key: "total_amount_sar",
              width: 120
            },
            {
              name: () => "AED",
              align: "left",
              key: "total_amount_aed",
              width: 120
            },
            {
              name: () => "QAR",
              key: "total_amount_qar",
              minWidth: 100
            },
            {
              name: () => "KWD",
              key: "total_amount_kwd",
              minWidth: 100
            }
          ]
        },
        {
          name: () => this.$t("to"),
          children: [
            {
              name: () => this.$t("currencyCode"),
              width: 80,
              key: "to_currency"
            },
            {
              name: () => this.$t("rate"),
              align: "left",
              key: "to_rate",
              width: 120
            }
          ]
        },

        {
          name: () => this.$t("receivable") + this.$t("total_amount"),
          children: [
            {
              name: () => "CNY",
              align: "left",
              key: "to_total_amount_cny",
              width: 140
            },
            {
              name: () => "USD",
              align: "left",
              key: "to_total_amount_usd",
              width: 140
            },
            {
              name: () => "SAR",
              align: "left",
              key: "to_total_amount_sar",
              width: 120
            },
            {
              name: () => "AED",
              align: "left",
              key: "to_total_amount_aed",
              width: 120
            },
            {
              name: () => "QAR",
              key: "to_total_amount_qar",
              minWidth: 100
            },
            {
              name: () => "KWD",
              key: "to_total_amount_kwd",
              minWidth: 100
            }
          ]
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          minWidth: 120
        },
        {
          name: () => this.$t("待核销金额"),
          key: "wait_amount",
          align: "left",
          minWidth: 120
        },
        {
          name: () => this.$t("Remarks"),
          key: "operator_remarks",
          minWidth: 100
        },
        {
          name: () => this.$t("createUser"),
          key: "creator_name",
          width: 170
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170
        },
        {
          name: () => this.$t("writeOffUser"),
          key: "write_off_name",
          width: 170
        },
        {
          name: () => this.$t("check_remarks"),
          key: "write_off_remarks",
          width: 170
        },
        {
          name: () => this.$t("writeOff") + this.$t("information"),
          children: [
            {
              name: () => this.$t("check_time"),
              align: "left",
              key: "check_time",
              width: 170
            },
            {
              name: () => this.$t("bank"),
              align: "left",
              key: "bank",
              width: 100
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              align: "left",
              minWidth: 120
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              align: "left",
              minWidth: 110
            },
            {
              name: () => this.$t("check_amount_currency"),
              key: "check_amount_currency",
              minWidth: 100
            }
          ]
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 300,
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            // {
            //   name: () => this.$t("addTo"),
            //   type: "add",
            //   fnName: "add",
            //   bind: {
            //     type: "error"
            //   }
            //   // disabled({ row }) {
            //   //   console.log(row);
            //   // }
            // },
            // {
            //   name: this.$t("rate"),
            //   type: "rate",
            //   fnName: "rate",
            //   bind: {
            //     type: "warning",
            //   },
            //   disabled({ row }) {
            //     return row.status == 4 || row.status == 8 || row.status == 9;
            //   },
            //   // id: 594,
            // },
            {
              name: this.$t("Append"),
              type: "append",
              fnName: "append",
              bind: {
                type: "warning"
              },
              disabled({row}) {
                return row.status != 1;
              }
              // id: 594,
            },
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              disabled({row}) {
                return row.status == 8 || row.status == 9;
              }
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "error"
              },
              disabled({row}) {
                return row.status != 1;
              }
              // id: 918,
            },
            {
              name: this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "primary"
              },
              disabled({row}) {
                return row.status != 4 && row.status != 8;
              }
              // id: 595,
            },
            {
              name: this.$t("writeOff") + this.$t("record"),
              type: "writeOffList",
              fnName: "writeOffList",
              bind: {
                type: "primary"
              },
              disabled({row}) {
                return row.status != 9 && row.status != 8;
              }
            },
            // {
            //   name: () => this.$t("resAmount"),
            //   align: "center",
            //   width: 100,
            //   fnName: "recalculate",
            //   // id: 608,
            //   bind: {
            //     type: "error",
            //     size: "small",
            //   },
            //   disabled({ row }) {
            //     return row.status == 4 || row.status == 8 || row.status == 9;
            //   },
            //   methods: {
            //     render() {
            //       return this.$t("resAmount");
            //     },
            //   },
            // },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              // id: 621,
              disabled({row}) {
                return row.status == 4 || row.status == 8 || row.status == 9;
              }
            },
            {
              name: () => this.$t("email") + this.$t("preview"),
              type: "preview",
              fnName: "preview",
              bind: {
                type: "success"
              },
              disabled({row}) {
                return row.status != 4;
              }
            }
          ],
          methods: {
            preview({row}) {
              previewEmail({bill_id: row.id}).then(res => {
                if (res.data.status) {
                  res.data.payload.id = row.id;
                  this.getModal("preview").open(res.data.payload, function () {
                    this.setTitle(
                      row.bill_number +
                      "(" +
                      this.$t("email") +
                      this.$t("preview") +
                      ")"
                    );
                  });
                }
              });
              // console.log(row);
            },
            writeOffList({row}) {
              this.handleRequestMethods("getWriteOffRecord", row.id).then(
                res => {
                  this.getModal("writeOffList").open({}, function () {
                    this.setTitle(this.$t("writeOff") + this.$t("record"));
                    this.list = res.payload;
                  });
                }
              );
            },
            append({row}) {
              this.getModal("append").open(
                {id: row.id, fn: "append"},
                function () {
                  this.setTitle(
                    row.bill_number + "(" + this.$t("Append") + ")"
                  );
                }
              );
            },
            // add({ row }) {
            //   this.getModal("add").open({ id: row.id }, function() {
            //     this.setTitle(row.bill_number + "(" + this.$t("addTo") + ")");
            //   });
            // },
            update({row}) {
              let data = {
                remarks: row.operator_remarks,
                name: row.name,
                id: row.id
              };
              this.getModal("update").open(data, function () {
                this.setTitle(row.bill_number + "(" + this.$t("update") + ")");
              });
            },
            writeOff({row}) {
              this.handleRequestMethods("getB2bBillDetails", {
                id: row.id
              }).then(res => {
                let data = res.payload;
                data.id = row.id;
                this.getModal("writeOff").open(data, function () {
                  // // this.list = this.billOrder = data.bill_order;
                  this.list = data.bill_order;
                  this.selectAll = data.bill_order;
                  this.$nextTick(() => {
                    this.$refs.table.$refs["xTable"].setAllCheckboxRow(true);
                  });
                  this.setTitle(
                    row.bill_number + "(" + this.$t("writeOff") + ")"
                  );
                });
              });
            },
            rate({row}) {
              this.getModal("rate").open(row, function () {
                this.setTitle(row.bill_number + "(" + this.$t("rate") + ")");
              });
            },
            recalculate({row}) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("againBillAmount", {
                    id: row.id
                  }).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            confirmOrder({row}) {
              console.log(row);
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("postConfirm", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            delete({row}) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("delDouBill", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  async created() {
    let service = (await getService()).data.payload;
    let data = (await getConfig()).data.payload;
    // let client = (await getAllClient()).data.payload.rows;
    let salesman = (await getUser({standard: "Salesman"})).data.payload.rows;
    this.$refs["table"].currency = data.currency;
    this.header.searchs.forEach(item => {
      if (item.key === "time_type") {
        item.options = data.time_type;
        this.$refs["table"].$refs["header"].searchForm["time_type"] =
          item.options[0].key;
      }
      if (item.key === "bill_status")
        item.options = Object.keys(data.bill_status).map(item => ({
          value: item,
          label: data.bill_status[item]
        }));
      // if (item.key === "client_id") item.options = client;
      if (item.key === "sale_id") item.options = salesman;
      if (item.key === "service_code") item.options = service;
    });
  }
};
</script>
